import { render, staticRenderFns } from "./company-view-recruitments.vue?vue&type=template&id=25f71970"
import script from "./company-view-recruitments.vue?vue&type=script&lang=js"
export * from "./company-view-recruitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports